import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import LoadingView from "../../modules/Loading/LoadingView";
import IntlTelInput from "react-intl-tel-input";
import Accounts from "./Accounts";
import AccountsAuth from "./AccountsAuth";
import AccountsAuthCode from "./AccountsAuthCode";
import AccountsSecurity from "./AccountsSecurity";
import AccountsDelete from "./AccountsDelete";
import AccountsDeleteCode from "./AccountsDeleteCode";
import AccountsImages from "./AccountsImages";
import AccountsTotp from "./AccountsTotp";

import { CopyToClipboard } from "react-copy-to-clipboard";

import { toMomentString } from "config/util";

import Switch from "@material-ui/core/Switch";
const Settings = ({
  loading,
  maps,
  accounts,
  kyc,
  dispatch_info,
  dispatch_danger,
  dispatch_put_accounts,
  dispatch_post_accounts_auth,
  dispatch_post_accounts_auth_code,
  dispatch_put_accounts_security,
  dispatch_get_accounts,
  dispatch_get_accounts_totp,
  dispatch_get_accounts_kyc,
  dispatch_delete_accounts,
  dispatch_delete_accounts_delete,
  dispatch_post_accounts_images,
  dispatch_delete_accounts_images_id,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  useEffect(() => {
    // window.Charts();
  }, []);
  const [country_code, set_country_code] = useState(accounts.country_code);
  const [RawPhoneNumber, set_RawPhoneNumber] = useState(accounts.phone_number);
  const [NewPhoneNumber, set_NewPhoneNumber] = useState("");

  const [accounts_auth_type, set_accounts_auth_type] = useState(null);
  const [accounts_auth_code_type, set_accounts_auth_code_type] = useState(null);

  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  const [modalAccounts, set_modalAccounts] = useState(false);

  const [modalAccountsAuth, set_modalAccountsAuth] = useState(false);
  const [modalAccountsAuthCode, set_modalAccountsAuthCode] = useState(false);
  const [modalAccountsTotp, set_modalAccountsTotp] = useState(false);

  const [modalAccountsImages, set_modalAccountsImages] = useState(false);
  const [modalAccountsDelete, set_modalAccountsDelete] = useState(false);
  const [modalAccountsDeleteCode, set_modalAccountsDeleteCode] = useState(
    false
  );
  const [modalAccountsSecurity, set_modalAccountsSecurity] = useState(false);

  return (
    <div className="wrapper">
      <Accounts
        loading={loading}
        modal={modalAccounts}
        close_modal={() => {
          set_modalAccounts(false);
        }}
        accounts={accounts}
        dispatch_put_accounts={dispatch_put_accounts}
      />
      <AccountsImages
        loading={loading}
        modal={modalAccountsImages}
        close_modal={() => {
          set_modalAccountsImages(false);
        }}
        kyc={kyc}
        accounts={accounts}
        dispatch_post_accounts_images={dispatch_post_accounts_images}
        dispatch_delete_accounts_images_id={dispatch_delete_accounts_images_id}
      />
      <AccountsAuth
        loading={loading}
        modal={modalAccountsAuth}
        close_modal={() => {
          set_modalAccountsAuth(false);
        }}
        next_modal={() => {
          set_modalAccountsAuthCode(true);
        }}
        accounts_auth_type={accounts_auth_type}
        accounts={accounts}
        dispatch_danger={dispatch_danger}
        dispatch_post_accounts_auth={dispatch_post_accounts_auth}
      />
      <AccountsTotp
        loading={loading}
        modal={modalAccountsTotp}
        close_modal={() => {
          set_modalAccountsTotp(false);
        }}
        accounts_auth_type={accounts_auth_type}
        accounts={accounts}
        dispatch_danger={dispatch_danger}
        dispatch_get_accounts_totp={dispatch_get_accounts_totp}
      />
      <AccountsAuthCode
        loading={loading}
        modal={modalAccountsAuthCode}
        close_modal={() => {
          set_modalAccountsAuthCode(false);
        }}
        accounts_auth_type={accounts_auth_type}
        accounts={accounts}
        dispatch_danger={dispatch_danger}
        dispatch_post_accounts_auth_code={dispatch_post_accounts_auth_code}
      />
      <AccountsSecurity
        loading={loading}
        modal={modalAccountsSecurity}
        close_modal={() => {
          set_modalAccountsSecurity(false);
        }}
        accounts={accounts}
        dispatch_put_accounts_security={dispatch_put_accounts_security}
      />
      <AccountsDelete
        loading={loading}
        modal={modalAccountsDelete}
        close_modal={() => {
          set_modalAccountsDelete(false);
        }}
        next_modal={() => {
          set_modalAccountsDeleteCode(true);
        }}
        accounts={accounts}
        dispatch_danger={dispatch_danger}
        dispatch_delete_accounts={dispatch_delete_accounts}
      />
      <AccountsDeleteCode
        loading={loading}
        modal={modalAccountsDeleteCode}
        close_modal={() => {
          set_modalAccountsDeleteCode(false);
        }}
        accounts={accounts}
        dispatch_delete_accounts_delete={dispatch_delete_accounts_delete}
      />

      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
          <div className="container-fluid">
            <div className="navbar-wrapper">
              <a className="navbar-brand" href="javascript:void(0);">
                <i className="material-icons">settings</i> {t("アカウント設定")}
              </a>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
            </button>
            <div className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    href="settings.html"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/settings`,
                      });
                      window.scroll(0, 0);
                    }}
                    style={{ textTransform: "none" }}
                  >
                    <i className="material-icons">account_circle</i>
                    {accounts.mail_address}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header card-header-dark">
                <h4 className="card-title">{t("アカウント情報")}</h4>
              </div>

              <div className="card-body">
                <dl className="row">
                  {/* <dt className="col-sm-3 text-sm-right">アカウント ID : </dt>
                  <dd className="col-sm-9">ABC1234</dd> */}
                  <dt className="col-sm-3 text-sm-right">{t("お名前：")} </dt>
                  <dd className="col-sm-9">{accounts.display_name}</dd>
                  <dt className="col-sm-3 text-sm-right">{t("生年月日：")} </dt>
                  <dd className="col-sm-9">
                    {toMomentString(accounts.birthday, "YYYY/MM/DD")}
                  </dd>
                  <dt className="col-sm-3 text-sm-right">{t("ご住所：")}</dt>
                  <dd className="col-sm-9">
                    {/* {accounts.postal_code ? `〒${accounts.postal_code}` : ""}{" "} */}
                    {accounts.address01} {accounts.address02}
                  </dd>
                  <dt className="col-sm-3 text-sm-right">{t("KYC：")}</dt>
                  <dd className="col-sm-9">
                    {accounts.verify_flg ? (
                      t("認証済み")
                    ) : (
                      <span style={{ color: "red" }}>
                        {t("生年月日と住所と本人確認書類の登録を行ってお待ちください。")}
                      </span>
                    )}
                  </dd>
                  <dd className="col-sm-9 offset-sm-3">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      // data-toggle="modal"
                      // data-target="#Accounts"
                      onClick={() => {
                        set_modalAccounts(true);
                      }}
                    >
                      {t("生年月日と住所の登録")}
                    </button>

                    <button
                      className="btn btn-outline-primary btn-sm"
                      // data-toggle="modal"
                      // data-target="#AccountsImages"
                      onClick={() => {
                        dispatch_get_accounts_kyc({}, () => {
                          set_modalAccountsImages(true);
                        });
                      }}
                    >
                      {t("本人確認書類の登録")}
                    </button>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="card">
              <div className="card-header card-header-dark">
                <h4 className="card-title">{t("認証情報")}</h4>
              </div>
              <div className="card-body">
                <dl className="row">
                  {/* <dt className="col-sm-3 text-sm-right">アカウント ID : </dt>
                  <dd className="col-sm-9">ABC1234</dd> */}
                  <dt className="col-sm-3 text-sm-right">{t("電話番号：")} </dt>
                  <dd className="col-sm-9">
                    <IntlTelInput
                      containerClassName="intl-tel-input"
                      inputClassName="form-control"
                      preferredCountries={["jp", "us"]}
                      defaultCountry={country_code}
                      allowDropdown={false}
                      placeholder=""
                      disabled={true}
                      value={RawPhoneNumber}
                      onSelectFlag={(value, obj, formattedvalue, isValid) => {
                        set_RawPhoneNumber(value);
                        // !isValid || set_NewPhoneNumber(formattedvalue.replace(/-/g,"").replace(/ /g,""));
                        !isValid || set_NewPhoneNumber(formattedvalue);
                        isValid || set_NewPhoneNumber("");
                      }}
                      // preferredCountries={["tw","jp"]}
                      onPhoneNumberChange={(
                        isValid,
                        value,
                        obj,
                        formattedvalue
                      ) => {
                        set_RawPhoneNumber(value);
                        // !isValid || set_NewPhoneNumber(formattedvalue.replace(/-/g,"").replace(/ /g,""));
                        !isValid || set_NewPhoneNumber(formattedvalue);
                        isValid || set_NewPhoneNumber("");
                      }}
                      // onPhoneNumberBlur={onBlur}
                      format
                    />
                  </dd>
                  <dt className="col-sm-3 text-sm-right">
                    {t("メールアドレス：")}
                  </dt>
                  <dd className="col-sm-9">{accounts.mail_address}</dd>
                  <dd className="col-sm-9 offset-sm-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        set_modalAccountsAuth(true);
                        set_accounts_auth_type(3);
                      }}
                    >
                      {t("電話番号を変更")}
                    </button>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        set_modalAccountsAuth(true);
                        set_accounts_auth_type(2);
                      }}
                    >
                      {t("メールアドレスを変更")}
                    </button>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        set_modalAccountsAuth(true);
                        set_accounts_auth_type(4);
                      }}
                    >
                      {t("パスワードを変更")}
                    </button>

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        set_modalAccountsTotp(true);
                      }}
                    >
                      {t("GoogleAuthenticatorを登録")}
                    </button>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="card">
              <div className="card-header card-header-dark">
                <h4 className="card-title">{t("セキュリティ情報")}</h4>
              </div>
              <div className="card-body">
                <dl className="row">
                  <dt className="col-sm-3 text-sm-right">{t("通知先：")} </dt>
                  <dd className="col-sm-9">
                    {t(maps.two_factor_types[accounts.two_factor_type])}
                  </dd>
                  <dt className="col-sm-3 text-sm-right">
                    {t("２ファクター認証：")}{" "}
                  </dt>
                  <dd className="col-sm-9">
                    <Switch
                      checked={accounts.two_factor_flg}
                      readOnly={true}
                      // checked={accounts.two_factor_flg}
                      // onChange={handleChange}
                      color="primary"
                      name="checkedB"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </dd>
                  <dd className="col-sm-9 offset-sm-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      // data-toggle="modal"
                      // data-target="#AccountsSecurity"
                      onClick={() => {
                        set_modalAccountsSecurity(true);
                      }}
                    >
                      {t("セキュリティ設定を変更")}
                    </button>
                  </dd>
                </dl>
              </div>
            </div>

            <div className="card">
              <div className="card-header card-header-dark">
                <h4 className="card-title">{t("紹介コード")}</h4>
              </div>
              <div className="card-body">
                <dl className="row">
                  <dt className="col-sm-3 text-sm-right">{t("紹介者：")} </dt>
                  <dd className="col-sm-9">{accounts.introducer}</dd>

                  <dt className="col-sm-3 text-sm-right">
                    {t("紹介コード付きURL：")}{" "}
                  </dt>
                  <dd className="col-sm-9">
                    <CopyToClipboard
                      // text={`https://www.sc-world-exchange.com/signup/${accounts.referral_code}`}
                      text={`https://www.sc-world-exchange.com/signup/${accounts.referral_code}`}
                      onCopy={() => {
                        dispatch_info(t("紹介コード付きURLをコピーしました。"));
                      }}
                    >
                      <button id="code" className="btn btn-link btn-sm">
                        <i className="material-icons">content_copy</i>{" "}
                        {`https://www.sc-world-exchange.com/signup/${accounts.referral_code}`}
                      </button>
                    </CopyToClipboard>
                  </dd>
                  <dt className="col-sm-3 text-sm-right">
                    {t("紹介コード：")}{" "}
                  </dt>
                  <dd className="col-sm-9">
                    <CopyToClipboard
                      text={`${accounts.referral_code}`}
                      onCopy={() => {
                        dispatch_info(t("紹介コードをコピーしました。"));
                      }}
                    >
                      <button id="code" className="btn btn-link btn-sm">
                        <i className="material-icons">content_copy</i>{" "}
                        {`${accounts.referral_code}`}
                      </button>
                    </CopyToClipboard>
                  </dd>
                </dl>
              </div>
            </div>

          
          </div>
        </div>
        <footer className="footer">
          <div className="container-fluid d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
            <div className="pl-3 ml-md-0">
              <small>Version 1.0.0</small>
            </div>
            <small>© SC WORLD EXCHANGE</small>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Settings;


// <div className="card">
// <div className="card-header card-header-dark">
//   <h4 className="card-title">{t("アカウント削除")}</h4>
// </div>
// <div className="card-body">
//   <dl className="row">
//     <dt className="col-sm-3 text-sm-right">{/* 通知先 :  */}</dt>
//     <dd className="col-sm-9"></dd>
//     <dt className="col-sm-3 text-sm-right">
//       {/* ２ファクター認証 :{" "} */}
//     </dt>
//     <dd className="col-sm-9"></dd>
//     <dd className="col-sm-9 offset-sm-3">
//       <button
//         className="btn btn-outline-primary btn-sm"
//         onClick={() => {
//           set_modalAccountsDelete(true);
//         }}
//       >
//         {t("アカウント削除")}
//       </button>
//     </dd>
//   </dl>
// </div>
// </div>